/*========================================================================
* $Id: value-binding.js -1M 2016-03-11 18:15:33Z (local) $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/



define([
// define([ todo:
    "api/v2/search",
    "client/template",
    "component!base",
    "utils/jsonpath",
    "underscore",
   ], function(
     Search,
     Template,
     Base,
     JSONPath,
     _
   ) {

  var ValueBinding = function () {
    return this.initialize.apply(this, arguments);
  };
  _.extend(ValueBinding.prototype, {

    initialize: function (bindingString, baseModel) {
      var bindingPath = JSONPath.parsePath(bindingString);
      if (bindingPath && bindingPath.length > 1) {
        if (bindingPath[0] === "facets") {
          var model;
          if (baseModel.searchModel) { // we have a FacetValueCollection
            model = baseModel;
          } else {
            model = new Search.FacetValueCollection(bindingPath[1], [{name: "html", formats: ["HTML"]}, {name: "count", formats: ["VALUE"]}], {});
          }

          model.on("all", function (type) {
            if (type === "change") return;
            model.trigger("change");
          });

          model.getData = function () {
            return [_.map(model.models, function (facetValue) {
              return [ facetValue.get("html"), facetValue.get("excluded") ? 0 : facetValue.get("count") ]
            })];
          };

          if (baseModel.addFacet) baseModel.addFacet(model, { silent: true });
          return model;
        } else if (bindingPath.length > 2 && bindingPath[0] === "resultset") {
          var properties = {};
          properties[bindingPath[2]] = { format: "VALUE" };
          properties["mes:date"] = { format: "VALUE" };
          properties["title"] = { format: "VALUE" };
          var model = new Search.ResultCollection(properties);
          model.on("all", function (type) {
              if (type === "change") return;
              model.trigger("change");
          });

          model.getData = function () {
/* TODO: aggregate value + count
            var aggregated = _.reduce(model.models, function (aggregated, resultValue) {
                var value = resultValue.get(bindingPath[2]);
                var count = aggregated[value] || 0;
                aggregated[value] = count + 1;
                return aggregated;
              }, {});

            return _.map(aggregated, function (count, key) {
                return [key, count];
            });
*/

            return _.reduce(model.models, function (data, resultValue) {
                var title = resultValue.get("title");
                var value = resultValue.get(bindingPath[2]);
		data[0].push([title, value && value.num || 0]);
                value = resultValue.get("mes:date");
		data[1].push([title, value.getTime() / 10000000]);
return data;
              }, [[],[]]);
          };

          if (baseModel.addResultCollection) baseModel.addResultCollection(model, { silent: true });
          return model;
        }
      }
    },

    destroy: function () {
      // TODO
    }

  });

  return ValueBinding;
});

